import React from 'react';
import useTitle from '../../../Hooks/useTitle';

const ReportedProducts = () => {
    useTitle('Reported Products')
    return (
        <div>
            here is all reported products
        </div>
    );
};

export default ReportedProducts;